import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { cloneDeep } from 'lodash';

import * as POSSelectors from 'PointOfSale/selectors';
import ServingOptions from 'PointOfSale/modules/servingOptions/component';
import * as servingMenuItemsActions from 'PointOfSale/modules/servingOptions/state/actions';
import {
  MENU_ITEMS as UNFILTERED_MENU_ITEMS,
  SessionTypes,
} from 'PointOfSale/modules/common/constants';

import 'PointOfSale/styles/components/pageHeader.less';
import 'PointOfSale/styles/components/pageFooter.less';

/** Disable Group for beta */
const MENU_ITEMS = UNFILTERED_MENU_ITEMS.filter(
  item => item.key !== SessionTypes.Group
);

const isSelected = (items, selectedMenu) => {
  return items.map(item => {
    if (item.key === selectedMenu) {
      item.selected = true;
    }
    return item;
  });
};

class ServingOptionsContainer extends Component {
  state = {
    items: cloneDeep(MENU_ITEMS),
  };

  componentDidMount() {
    const {
      servingMenuItemsActions: { clearCurrentSession, getServingSubMenuItems },
    } = this.props;
    clearCurrentSession();
    getServingSubMenuItems();
  }

  setCurrentSession = menuName => {
    const currentSession = {
      type: menuName,
      timeInterval: 5,
      autoServe: false,
      quickServeItem: false,
      quickServeSelectedItem: '',
    };

    this.props.servingMenuItemsActions.setCurrentSession(currentSession);
  };

  handleOnClickMenuItem = menuName => {
    const menuItems = cloneDeep(MENU_ITEMS);
    this.setState({
      items: isSelected(menuItems, menuName),
      currentSelectedMenu: menuName,
    });

    this.setCurrentSession(menuName);
    this.props.servingMenuItemsActions.getServingSubMenuItems();
  };

  onClickReset = () => {
    this.setState({
      items: MENU_ITEMS,
      currentSelectedMenu: '',
    });

    this.props.servingMenuItemsActions.clearCurrentSession();
  };

  render() {
    const { currentSelectedMenu, items } = this.state;
    return (
      <ServingOptions
        currentSelectedMenu={currentSelectedMenu}
        items={items}
        handleOnClickMenuItem={this.handleOnClickMenuItem}
        onClickReset={this.onClickReset}
      />
    );
  }
}

const mapStateToProps = state => ({
  selectedMealType: POSSelectors.getCurrentSelectedMenu(state),
  selectedSiteDetails: POSSelectors.getSelectedSiteDetails(state),
});

const mapDispatchToProps = dispatch => ({
  servingMenuItemsActions: bindActionCreators(
    servingMenuItemsActions,
    dispatch
  ),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ServingOptionsContainer)
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/servingOptions/container/index.js